<script lang="ts">
import { modifiers } from "../store";

export let index: number;
export let key: string;
</script>
<div class="form-group mb-3">
	<label for={`Modifiers${index}.${key}`} class="text-capitalize">{key}</label>
	<input type="color" class="form-control form-control-color" id={`Modifiers${index}.${key}`} bind:value={$modifiers[index][key]}>
</div>
